import { ChangeIndicatorClass, OrderDirection } from 'webapp/enums/enums';

function getChangeDirection(changeStr: string): string {
	if (changeStr) {
		if (changeStr.startsWith('▼')) {
			return OrderDirection.DESC;
		} else if (changeStr.startsWith('▲')) {
			return OrderDirection.ASC;
		}
	}
	return '';
}

function getPreviewChangeIndicatorClass(
	changeStr: string,
	isInverse: boolean,
): ChangeIndicatorClass | '' {
	let indicatorClass: ChangeIndicatorClass | '' = '';

	if (changeStr) {
		if (getChangeDirection(changeStr) === OrderDirection.DESC) {
			indicatorClass = isInverse
				? ChangeIndicatorClass.POSITIVE
				: ChangeIndicatorClass.NEGATIVE;
		} else if (getChangeDirection(changeStr) === OrderDirection.ASC) {
			indicatorClass = isInverse
				? ChangeIndicatorClass.NEGATIVE
				: ChangeIndicatorClass.POSITIVE;
		}
	}

	return indicatorClass;
}

function getHTMLElFromSVG(svgElement: SVGElement): HTMLElement {
	const rect = svgElement.getBoundingClientRect();
	const htmlEl = document.createElement('div');
	htmlEl.style.position = 'fixed';
	htmlEl.style.left = rect.left + 'px';
	htmlEl.style.top = rect.top + 'px';
	htmlEl.style.width = rect.width + 'px';
	htmlEl.style.height = rect.height + 'px';

	const transform = window.getComputedStyle(svgElement).getPropertyValue('transform');
	if (transform && transform !== 'none') {
		htmlEl.style.transform = transform;
		htmlEl.style.transformOrigin = 'top left';
	}

	return htmlEl;
}

export { getChangeDirection, getPreviewChangeIndicatorClass, getHTMLElFromSVG };
